export const HEARTBEAT_INTERVAL_MS = 5000;

export const POLLING_INTERVAL_MS = 2000;

export const REFLECTION_QUALITY_THRESHOLD = 50;

export const ACTION_TEXT_MAX_LENGTH = 2000;

export const REFLECTION_TEXT_MAX_LENGTH = 1000;

export const RECONNECTION_ATTEMPTS = 10;

export const RECONNECTION_DELAY = 1000;

export const RECONNECTION_DELAY_MAX = 10000;

export const SOCKET_NAMESPACE = '/simulation';
